// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../Config.bs.js";

function getTrackOrder(url) {
  var match = url.path;
  if (match && match.hd === "track_live_order" && !match.tl) {
    window.open(Config.Env.getHostName(undefined) + ("/track_live_order?" + url.search), "_parent");
    return ;
  }
  
}

var RouteManager = {
  getTrackOrder: getTrackOrder
};

export {
  RouteManager ,
  
}
/* Config Not a pure module */
